import { DOCUMENT } from '@angular/common';
import { NgModule, Provider } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  NgcCookieConsentConfig,
  NgcCookieConsentModule,
  NgcCookieConsentService,
  WindowService,
} from 'ngx-cookieconsent';

const CONSEST_BANNER_CONFIG_PROVIDER: Provider = {
  deps: [TranslateService, DOCUMENT],
  provide: NgcCookieConsentConfig,
  useFactory: (translateService: TranslateService, document: Document): NgcCookieConsentConfig => {
    const translate = (key: string | Array<string>, interpolateParams?: object) =>
      translateService.instant(key, interpolateParams) as string;

    return {
      type: 'info',
      theme: 'classic',
      cookie: { domain: document.location.hostname },
      compliance: { info: '<div class="cc-compliance cc-highlight">{{deny}}{{allow}}</div>' },

      elements: {
        messagelink: `<span id="cookieconsent:desc" class="cc-message">
          {{firstPartOfMessage}}
          <a tabindex="1" class="cc-link" href="{{privacyPolicyHref}}" target="_self" rel="noopener">
          {{privacyPolicyLink}}</a>
          {{secondPartOfMessage}}</span>`,
      },

      palette: {
        popup: { background: '#fff', link: '#50c29c' },
        button: { background: '#50c29c;', text: '#fff' },
      },

      content: {
        privacyPolicyHref: `${document.location.origin}/terms`,
        deny: translate('COOKIE_CONSENT_BANNER.DENNY_BUTTON_TEXT'),
        allow: translate('COOKIE_CONSENT_BANNER.ALLOW_BUTTON_TEXT'),
        privacyPolicyLink: translate('COOKIE_CONSENT_BANNER.PRIVACY_POLICY'),
        firstPartOfMessage: translate('COOKIE_CONSENT_BANNER.FIRST_PART_MESSAGE'),
        secondPartOfMessage: translate('COOKIE_CONSENT_BANNER.SECOND_PART_MESSAGE'),
      },
    };
  },
};

@NgModule({
  imports: [NgcCookieConsentModule],
  providers: [NgcCookieConsentService, WindowService, CONSEST_BANNER_CONFIG_PROVIDER],
})
export class AppCookieConsentModule {}
